import React, { useContext, useEffect, useState } from "react";
import Card from "../../components/Card/Card";
import Row, { Col } from "../../Layout/Responsive";
import { colors, getIcon, getLink, tabs } from "../../utils";
import { sayak, tej } from "../../utils/images";
import _ from "lodash";
import "./team.scss";
import { Link } from "react-router-dom";
import Chip from "../../components/Chip/Chip";
import GlobalContext from "../../context/GlobalContext";

const Team = () => {
	const { team, getAllPeople, restructureTeam } = useContext(GlobalContext);
	const createTeam = async () => {
		const allPeople = await getAllPeople();
		restructureTeam(allPeople);
	};
	useEffect(() => {
		createTeam();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const [activeTab, setActiveTab] = useState("");
	const heroCore = [
		{
			name: "Tejendra Saini",
			image: tej,
			title: "Full Stack developer",
			status: "Founder",
			email: "tejrajoriya807@gmail.com",
			socials: [
				{
					service: "Linkedin",
					username: "tejendrasaini",
				},
				{
					service: "Instagram",
					username: "mr._tezz",
				},
				{
					service: "Phone",
					username: " 7876239520",
				},
				{
					service: "Mail",
					username: "tejrajoriya807@gmail.com",
				},
				{
					service: "Twitter",
					username: "BllindUser",
				},
			],
			color: colors[Math.floor(Math.random() * colors.length)],
		},
		{
			name: "Sayak Mondal",
			image: sayak,
			title: "Frontend developer",
			status: "Secretary",
			email: "sayakmondal2001@gmail.com",
			socials: [
				{
					service: "Linkedin",
					username: "tejendrasaini",
				},
				{
					service: "Instagram",
					username: "ig_d3monic",
				},
				{
					service: "Phone",
					username: " 7876239520",
				},
				{
					service: "Mail",
					username: "sayakmondal2001@gmail.com",
				},
			],
			color: colors[Math.floor(Math.random() * colors.length)],
		},
	];
	return (
		<main className="team">
			<section className="team-hero">
				<div className="team-hero-left">
					<h1>Team</h1>
					<p>
						Meet our team made up of creatives with technical
						knowhow, strategists who think outside the box and
						people who push beyond innovation.
					</p>
				</div>
				<div className="team-hero-right">
					{heroCore.map((member, id) => (
						<div
							className="team-hero-card"
							style={{
								backgroundImage: `url(${member.image})`,
							}}
							key={id}
						>
							<div className="team-hero-card-content">
								<h1 className="team-hero-card__name">
									{member.name}
								</h1>
								<p className="team-hero-card__status">
									{member.status}
								</p>
								<p className="team-hero-card__title">
									{member.title}
								</p>
								<div className="team-hero-card-socials">
									{member.socials.map((social, index) => (
										<a
											href={getLink(
												social.service,
												social.username
											)}
											title={`${social.service}/${social.username}`}
											key={index}
											target="_blank"
											rel="noreferrer"
											className={`card-social ${_.lowerCase(
												social.service
											)}`}
										>
											{getIcon(social.service)}
										</a>
									))}
								</div>
							</div>
						</div>
					))}
				</div>
			</section>
			<section className="team-labels">
				{tabs.map((tab, index) => (
					<Chip
						key={index}
						icon={tab.icon}
						text={tab.title}
						style={{
							backgroundColor: `var(--${tab.color}-${
								activeTab === tab.id ? 700 : 100
							})`,
							color:
								activeTab === tab.id
									? "var(--white)"
									: `var(--${tab.color}-700)`,
							border: `2px solid var(--${tab.color - 700})`,
						}}
						onClick={() => setActiveTab(() => tab.id)}
					/>
				))}
			</section>
			<section className="team-people">
				{team.map(
					(group, id) =>
						group.members.length > 0 &&
						(group.members.some((p) =>
							p.tags.includes(activeTab)
						) ||
							activeTab === "") && (
							<div className="team-group" key={id}>
								<h1 className="team-group__title">
									{group.title}
								</h1>
								<Row>
									{group.members.map(
										(person, index) =>
											person.verified &&
											(person.tags.includes(activeTab) ||
												activeTab === "") && (
												<Col
													lg={33}
													md={50}
													sm={100}
													key={index}
												>
													<Card {...person} />
												</Col>
											)
									)}
								</Row>
							</div>
						)
				)}
			</section>
			<section className="team-add">
				<span>Are you a member, but couldn't find yourself here?</span>
				<Link to="/forms/add-member-details">
					Add Your Details Here
				</Link>
			</section>
		</main>
	);
};

export default Team;
